export const GmailIcon = () => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_383_26244)">
      <path
        d="M1.64075 17.9999H5.46917V8.74279L0 4.6285V16.3606C0 17.2606 0.739946 17.9999 1.64075 17.9999Z"
        fill="#4285F4"
      />
      <path
        d="M18.5635 17.9998H22.3919C23.2927 17.9998 24.0326 17.2605 24.0326 16.3605V4.62838L18.5635 8.71052"
        fill="#34A853"
      />
      <path
        d="M18.5635 1.63927V8.74284L24.0326 4.6607V2.44284C24.0326 0.417844 21.7163 -0.739299 20.1077 0.48213"
        fill="#FBBC04"
      />
      <path
        d="M5.46973 8.74269V1.63912L12.0327 6.55698L18.5636 1.63912V8.74269L12.0006 13.6284"
        fill="#EA4335"
      />
      <path
        d="M0 2.44282V4.62853L5.46917 8.71067V1.63925L3.92493 0.482103C2.31635 -0.707182 0 0.449961 0 2.44282Z"
        fill="#C5221F"
      />
    </g>
    <defs>
      <clipPath id="clip0_383_26244">
        <rect width="24" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
